import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute, useRouter } from 'vue-router';
    import { computed } from 'vue';
    import { useListeners } from '@/Composables/useListeners';

    
export default {
  __name: 'RouterIndicator',
  props: {
        to: { type: [String, Object, Array], default: null },
        tag: { type: String, default: 'div' },
        exact: { type: Boolean, default: false },
        activeClass: { type: String, default: 'router-link-active' },
        exactActiveClass: { type: String, default: 'router-link-exact-active' },
    },
  setup(__props) {

    const props = __props;

    const route = useRoute();
    const router = useRouter();

    const { listeners } = useListeners();

    // Resolve `to` to a path. For unmatched routes (e.g. URL prefixes for grouped nav items
    // like '/admin/system'), fall back to the raw string instead of warning via useLink.
    const resolvedPath = computed(() => {
        if (!props.to) return null;
        if (typeof props.to === 'string') return props.to;
        try {
            return router.resolve(props.to).path;
        }
        catch {
            return null;
        }
    });

    const isExactActive = computed(() => resolvedPath.value && route.path === resolvedPath.value);
    const isActive = computed(() => resolvedPath.value && route.path.startsWith(resolvedPath.value));

    const classes = computed(() => {
        if (!props.to) return {};

        return {
            [props.activeClass]: props.exact ? isExactActive.value : isActive.value,
            [props.exactActiveClass]: isExactActive.value,
        };
    });

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), _mergeProps({ class: classes.value }, _unref(listeners)), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["class"]))
}
}

}